import axiosClient from "utils/api";
const URI = "/admin/maliciousword";

export const getMaliciousWords = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get malicious words:", error);
    throw error;
  }
};

export const updateMaliciousWords = async ({ id, ...data }) => {
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: data,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during update malicious words:", error);
    throw error;
  }
};
export const getUserMaliciousReports = async (payload) => {
  const URL = `${URI}/usedMaliciousWord`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get malicious words:", error);
    throw error;
  }
};

export const addMaliciousWord = async (payload) => {
  try {
    const response = await axiosClient().request({
      url: URI,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error in add malicious words:", error);
    throw error;
  }
};

export const deleteMaliciousWord = async (id) => {
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during delete malicious word:", error);
    throw error;
  }
};
